module.exports = __webpack_public_path__ + "img/table-tennis-game.cf709065.jpg";